/* tslint:disable */
/* eslint-disable */
/**
 * documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EditStorageRequest,
  PickStorageIdOrNameOrTenant,
  RestoreBackup200Response,
  Storage,
  WebDAVCreate,
} from '../models/index';

export interface TenantApiCreateWebdavRequest {
    tenant: string;
    webDAVCreate: WebDAVCreate;
}

export interface TenantApiEditStorageOperationRequest {
    tenant: string;
    storage: number;
    editStorageRequest: EditStorageRequest;
}

export interface TenantApiGetStorageBackupRequest {
    tenant: string;
    storage: number;
}

export interface TenantApiGetStorageBackupDateRequest {
    tenant: string;
    storage: number;
}

export interface TenantApiRemoveStorageRequest {
    tenant: string;
    storage: number;
}

export interface TenantApiRenewWebdavRequest {
    tenant: string;
    storage: number;
    webDAVCreate: WebDAVCreate;
}

export interface TenantApiRestoreBackupRequest {
    tenant: string;
    storage: number;
    body?: Blob;
}

export interface TenantApiStorageRequest {
    tenant: string;
    storage: number;
}

export interface TenantApiStoragesRequest {
    tenant: string;
}

export interface TenantApiStoragesInfoRequest {
    tenant: string;
}

/**
 * 
 */
export class TenantApi extends runtime.BaseAPI {

    /**
     */
    async createWebdavRaw(requestParameters: TenantApiCreateWebdavRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling createWebdav().'
            );
        }

        if (requestParameters['webDAVCreate'] == null) {
            throw new runtime.RequiredError(
                'webDAVCreate',
                'Required parameter "webDAVCreate" was null or undefined when calling createWebdav().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/webdav`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['webDAVCreate'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createWebdav(tenant: string, webDAVCreate: WebDAVCreate, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createWebdavRaw({ tenant: tenant, webDAVCreate: webDAVCreate }, initOverrides);
        return await response.value();
    }

    /**
     */
    async editStorageRaw(requestParameters: TenantApiEditStorageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling editStorage().'
            );
        }

        if (requestParameters['storage'] == null) {
            throw new runtime.RequiredError(
                'storage',
                'Required parameter "storage" was null or undefined when calling editStorage().'
            );
        }

        if (requestParameters['editStorageRequest'] == null) {
            throw new runtime.RequiredError(
                'editStorageRequest',
                'Required parameter "editStorageRequest" was null or undefined when calling editStorage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/storage/{storage}/edit`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))).replace(`{${"storage"}}`, encodeURIComponent(String(requestParameters['storage']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['editStorageRequest'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async editStorage(tenant: string, storage: number, editStorageRequest: EditStorageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.editStorageRaw({ tenant: tenant, storage: storage, editStorageRequest: editStorageRequest }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStorageBackupRaw(requestParameters: TenantApiGetStorageBackupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling getStorageBackup().'
            );
        }

        if (requestParameters['storage'] == null) {
            throw new runtime.RequiredError(
                'storage',
                'Required parameter "storage" was null or undefined when calling getStorageBackup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/storage/{storage}/backup`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))).replace(`{${"storage"}}`, encodeURIComponent(String(requestParameters['storage']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getStorageBackup(tenant: string, storage: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getStorageBackupRaw({ tenant: tenant, storage: storage }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStorageBackupDateRaw(requestParameters: TenantApiGetStorageBackupDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling getStorageBackupDate().'
            );
        }

        if (requestParameters['storage'] == null) {
            throw new runtime.RequiredError(
                'storage',
                'Required parameter "storage" was null or undefined when calling getStorageBackupDate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/storage/{storage}/backupdate`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))).replace(`{${"storage"}}`, encodeURIComponent(String(requestParameters['storage']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getStorageBackupDate(tenant: string, storage: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getStorageBackupDateRaw({ tenant: tenant, storage: storage }, initOverrides);
        return await response.value();
    }

    /**
     */
    async removeStorageRaw(requestParameters: TenantApiRemoveStorageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling removeStorage().'
            );
        }

        if (requestParameters['storage'] == null) {
            throw new runtime.RequiredError(
                'storage',
                'Required parameter "storage" was null or undefined when calling removeStorage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/storage/{storage}`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))).replace(`{${"storage"}}`, encodeURIComponent(String(requestParameters['storage']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeStorage(tenant: string, storage: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeStorageRaw({ tenant: tenant, storage: storage }, initOverrides);
    }

    /**
     */
    async renewWebdavRaw(requestParameters: TenantApiRenewWebdavRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling renewWebdav().'
            );
        }

        if (requestParameters['storage'] == null) {
            throw new runtime.RequiredError(
                'storage',
                'Required parameter "storage" was null or undefined when calling renewWebdav().'
            );
        }

        if (requestParameters['webDAVCreate'] == null) {
            throw new runtime.RequiredError(
                'webDAVCreate',
                'Required parameter "webDAVCreate" was null or undefined when calling renewWebdav().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/storage/{storage}/renew/webdav`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))).replace(`{${"storage"}}`, encodeURIComponent(String(requestParameters['storage']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['webDAVCreate'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async renewWebdav(tenant: string, storage: number, webDAVCreate: WebDAVCreate, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.renewWebdavRaw({ tenant: tenant, storage: storage, webDAVCreate: webDAVCreate }, initOverrides);
        return await response.value();
    }

    /**
     */
    async restoreBackupRaw(requestParameters: TenantApiRestoreBackupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RestoreBackup200Response>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling restoreBackup().'
            );
        }

        if (requestParameters['storage'] == null) {
            throw new runtime.RequiredError(
                'storage',
                'Required parameter "storage" was null or undefined when calling restoreBackup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/octet-stream';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/storage/{storage}/restore`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))).replace(`{${"storage"}}`, encodeURIComponent(String(requestParameters['storage']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async restoreBackup(tenant: string, storage: number, body?: Blob, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RestoreBackup200Response> {
        const response = await this.restoreBackupRaw({ tenant: tenant, storage: storage, body: body }, initOverrides);
        return await response.value();
    }

    /**
     */
    async storageRaw(requestParameters: TenantApiStorageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Storage>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling storage().'
            );
        }

        if (requestParameters['storage'] == null) {
            throw new runtime.RequiredError(
                'storage',
                'Required parameter "storage" was null or undefined when calling storage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/storage/{storage}`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))).replace(`{${"storage"}}`, encodeURIComponent(String(requestParameters['storage']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storage(tenant: string, storage: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Storage> {
        const response = await this.storageRaw({ tenant: tenant, storage: storage }, initOverrides);
        return await response.value();
    }

    /**
     */
    async storagesRaw(requestParameters: TenantApiStoragesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Storage>>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling storages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/storages`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storages(tenant: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Storage>> {
        const response = await this.storagesRaw({ tenant: tenant }, initOverrides);
        return await response.value();
    }

    /**
     */
    async storagesInfoRaw(requestParameters: TenantApiStoragesInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PickStorageIdOrNameOrTenant>>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling storagesInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["token"] = await this.configuration.apiKey("token"); // header authentication
        }

        const response = await this.request({
            path: `/tenant/{tenant}/storages/info`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storagesInfo(tenant: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PickStorageIdOrNameOrTenant>> {
        const response = await this.storagesInfoRaw({ tenant: tenant }, initOverrides);
        return await response.value();
    }

}
